import { useAbility } from 'permissions/hooks/useAbility.ts';
import { Actions, Subjects } from 'permissions/ability.ts';

export const useProductsManagementAvailable = () => {
  const ability = useAbility();
  return ability.can(Actions.read, Subjects.productsManagement);
};
